import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ width: "56", height: "56", viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }, this.props),
            React.createElement("g", { fill: "#FFF", fillRule: "evenodd" },
                React.createElement("path", { d: "M28 53c13.807 0 25-11.193 25-25S41.807 3 28 3 3 14.193 3 28s11.193 25 25 25zm0 3C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z" }),
                React.createElement("path", { d: "M37.232 27.91L22 36.82V19z" })));
    };
    return SVG;
}(React.Component));
export default SVG;
